export default __webpack_public_path__ + "static/media/eject.e672c2c9.mp3";